import "./mobileMenuStyle.css"
import { useState } from "react";
import { IoMenu } from "react-icons/io5";
import AnchorMobileButton from "../mobileAnchorButton/anchorMobileButton";
import useSetSiteLanguage from "../../../../hooks/useSetSiteLanguage";

export default function MobileMenu() {
    const siteContent = useSetSiteLanguage();


    const [ menuIsOpen, setMenuIsOpen] = useState(false);
    var header = document.querySelector('header');
    var headerHeight;
    if (header) headerHeight = header.offsetHeight;

    const mobileDropMenu = {
        top: headerHeight
    }


    return(
        <div className="mobile-menu__container" onClick={() => setMenuIsOpen(!menuIsOpen)}>
            {!menuIsOpen ?
                <IoMenu className="mobile-menu__icon" />
            :
            <>
                <IoMenu className="mobile-menu__icon"p />
                <div className="navbar-anchor-buttons__mobile" style={headerHeight? mobileDropMenu : {}}>
                    {siteContent?.navbar?.map( (item, index) => (
                        <AnchorMobileButton text={item?.text} href={item?.url} key={index}/>
                    ))}
                </div>
            </>
            }
        </div>
    );
}